var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWithCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0757 26.5894C6.00781 26.5894 0.185059 20.7666 0.185059 13.6865C0.185059 6.61865 5.99561 0.795898 13.0757 0.795898C20.1436 0.795898 25.9663 6.61865 25.9663 13.6865C25.9663 20.7666 20.1558 26.5894 13.0757 26.5894ZM13.0757 23.3789C18.4468 23.3789 22.7559 19.0576 22.7559 13.6865C22.7559 8.32764 18.4346 4.00635 13.0757 4.00635C7.70459 4.00635 3.40771 8.32764 3.40771 13.6865C3.40771 19.0576 7.7168 23.3789 13.0757 23.3789ZM9.31592 18.7524C8.5835 18.7524 8.00977 18.1787 8.00977 17.4341C8.00977 17.0923 8.14404 16.7627 8.40039 16.5186L11.208 13.7109L8.40039 10.8911C8.14404 10.647 8.00977 10.3296 8.00977 9.98779C8.00977 9.24316 8.5835 8.66943 9.31592 8.66943C9.71875 8.66943 10.0239 8.7915 10.2803 9.06006L13.0757 11.8433L15.8833 9.04785C16.1519 8.7793 16.457 8.65723 16.8477 8.65723C17.5801 8.65723 18.1538 9.23096 18.1538 9.97559C18.1538 10.3174 18.0195 10.6226 17.7632 10.8911L14.9556 13.7109L17.751 16.5186C18.0073 16.7627 18.1538 17.0801 18.1538 17.4341C18.1538 18.1787 17.5801 18.7524 16.8354 18.7524C16.4448 18.7524 16.1274 18.6182 15.8711 18.3618L13.0757 15.5786L10.2925 18.3618C10.0361 18.6304 9.71875 18.7524 9.31592 18.7524Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWithCircle);
export default __webpack_public_path__ + "static/media/closeWithCircle.9b03e0eca69d20288dbe162a429b67e6.svg";
export { ForwardRef as ReactComponent };